import PageTemplate from './PageTemplate';
import './ModulePage.css';

function Assignments() {
  return (
    <PageTemplate title="Assignments" subtitle="Manage assignments and submissions">
      <div className="module-placeholder">
        <div className="module-actions">
          <input type="search" placeholder="Search assignments..." className="search-input" />
          <button className="btn-primary">Create Assignment</button>
        </div>
        <div className="placeholder-table">
          <p>Assignment management interface will be implemented here.</p>
          <ul>
            <li>Create assignments</li>
            <li>Review submissions</li>
            <li>Grade and feedback</li>
            <li>Due dates</li>
          </ul>
        </div>
      </div>
    </PageTemplate>
  );
}

export default Assignments;
